import { Card } from '@chakra-ui/react';
import { SettingCardType } from '@monetize/types/app';
import { FC } from 'react';
import { SETTING_CARD_LOGOS } from '../../constants/settings';
import { MCloseButton, MFlex, MText } from '../Monetize';

interface SettingCardEditProps {
  type: SettingCardType;
  showCloseButton?: boolean;
  handleCancel?: () => void;
  children: React.ReactNode;
}

export const SettingCardEdit: FC<SettingCardEditProps> = ({
  type,
  showCloseButton = false,
  handleCancel = () => {},
  children,
}) => {
  const Logo = SETTING_CARD_LOGOS[type];

  return (
    <Card.Root variant="edit" w="600px">
      <Card.Header>
        <MFlex justifyContent="space-between" alignItems="center">
          <MFlex alignItems="center">
            <Logo />
            <MText ml={2} fontSize="sm">
              {type}
            </MText>
          </MFlex>
          {showCloseButton && <MCloseButton onClick={handleCancel} />}
        </MFlex>
      </Card.Header>
      <Card.Body>{children}</Card.Body>
    </Card.Root>
  );
};
